import { render, staticRenderFns } from "./TransactionPage.vue?vue&type=template&id=937693e8&scoped=true"
import script from "./TransactionPage.vue?vue&type=script&lang=js"
export * from "./TransactionPage.vue?vue&type=script&lang=js"
import style0 from "./TransactionPage.vue?vue&type=style&index=0&id=937693e8&prod&style=true&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "937693e8",
  null
  
)

export default component.exports